<script>
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
    export default {
        props: {
            modelValue: String|HTMLCanvasElement,
            image: String|null,
            toolbar: {
                type: Boolean,
                default: true,
            },
            zoomSlider: {
                type: Boolean,
                default: false,
            },
            viewMode: {
                type: Number,
                default: 3,
            },
            circle: {
                type: Boolean,
                default: false,
            },
            zoomOnTouch: {
                type: Boolean,
                default: true
            },
            zoomOnWheel: {
                type: Boolean,
                default: true
            },
            minContainerWidth: Number,
            minContainerHeight: Number,
            autoCropArea: Number,
            aspectRatio: Number,
        },
        components: { VueCropper },
        data () {
            return {
                enabled: false,
                imageMode: false,
                locked: false,
                cropData: null,
                zoomSliderVisible: false,
            }
        },
        methods: {
            roundValues(object) {
                const newObject = {};

                for (const key in object) {
                    newObject[key] = parseFloat(object[key]);
                }

                return newObject;
            },

            setImageMode(imageMode) {
                this.imageMode = imageMode;
            },

            lock() {
                this.locked = true;
                this.$refs.cropper.disable();
            },

            destroy() {
                this.$refs.cropper.destroy();
            },

            unlock() {
                this.locked = false;
                this.$refs.cropper.enable();
            },

            replace (image)  {
                this.unlock();
                this.$refs.cropper.replace(image);
            },

            onCropMove(e) {
                this.emitOnChange(e);
            },

            onCropZoom(e) {
                this.emitOnChange(e);
            },

            emitOnChange(e) {
                const imageData = this.$refs.cropper.getImageData();
                const cropData = this.$refs.cropper.getData();
                // const cropBoxData = this.$refs.cropper.getCropBoxData();
                const canvasData = this.$refs.cropper.getCanvasData();

                const extra = { zoom: imageData.width / imageData.naturalWidth };

                this.$emit('onChange', {
                    cropData: cropData,
                    canvasData: canvasData,
                    extra: extra,
                });
            },

            setData(data) {
                this.cropData = data;
            },

            onReady(e) {
                // this.enabled = true;
                 this.enabled = true;

                if (this.zoomSlider && this.$refs.zoom) {
                    const imageData = this.$refs.cropper.getCanvasData();
                    const minSliderZoom = imageData.width / imageData.naturalWidth;
                    this.$refs.zoom.min = minSliderZoom;
                    this.$refs.zoom.value = minSliderZoom;
                    // this.$refs.zoom.value = this.cropData?.extra?.zoom ? this.cropData.extra.zoom : minSliderZoom;
                }

                // if (this.cropData.canvasData) {
                    // this.$refs.cropper.setCanvasData(this.roundValues(this.cropData.canvasData));
                    // this.$refs.cropper.setData(this.cropData.cropData);
                // }

                if (this.locked) {
                    this.$refs.cropper.disable();
                }

                // this.$refs.cropper.setData(this.cropData);
                // this.$refs.cropper.zoomTo(this.cropData.zoom);/

                this.$emit('ready', this.$refs.cropper);

                this.emitOnChange(e);
            },

            crop() {
                this.$emit('onCrop', this.$refs.cropper.getCroppedCanvas());
            },

            onZoom(event) {
                var zoomValue = parseFloat(event.target.value);
                this.$refs.cropper.zoomTo(zoomValue);
            }
        }
    }
</script>

<template>
    <div class="relative">
        <div class="absolute z-[8] right-0" v-show="enabled && toolbar">
            <button
                v-if="enabled && !locked && !imageMode"
                @click="lock"
                class="bg-red-500 text-white mr-2">Lås</button>

            <button
                v-if="enabled && locked && !imageMode"
                @click="unlock"
                class="bg-red-500 text-white mr-2">Lås upp</button>

            <button
                @click="$emit('startUpload')"
                class="bg-red-500 text-white">Ladda upp</button>
        </div>

        <div class="aspect-w-4 aspect-h-3">
            <vue-cropper
                :class="{ 'cropper-circle': circle, 'opacity-0': !enabled }"
                ref="cropper"
                :src="modelValue"
                :background="false"
                :responsive="true"
                dragMode="move"
                :viewMode="viewMode"
                :cropBoxMovable="false"
                :autoCropArea="1"
                :cropBoxResizable="false"
                :guides="false"
                :center="false"
                :toggleDragModeOnDblclick="false"
                :min-container-width="minContainerWidth"
                :min-container-height="minContainerHeight"
                :auto-crop-area="autoCropArea"
                :aspect-ratio="aspectRatio"
                :zoom-on-wheel="zoomOnWheel"
                :zoom-on-touch="zoomOnTouch"
                :restore="false"

                @ready="onReady"
                @cropmove="onCropMove"
                @zoom="onCropZoom"/>

                <div v-if="!enabled && toolbar">
                    <div
                        class="h-full w-full border-dashed border-2 flex justify-center items-center">
                        <button @click="$emit('startUpload')" class="text-sm bg-indigo-500 text-white rounded-md px-4 py-2 font-semibold tracking-wide inline-flex items-center justify-center" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                            Ladda upp bild
                        </button>
                    </div>
                </div>
        </div>

        <div class="flex mt-4" v-if="zoomSlider" v-show="enabled">
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12H6" />
                </svg>
            </div>
            <input
                class="w-full"
                @input="onZoom($event)"
                type="range"
                min="0"
                max="4"
                step="0.01"
                value="0"
                ref="zoom"/>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
            </div>
        </div>
    </div>
</template>
